<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal">
  <div class="modal-header">
    <h3>{{ (mode === 'edit' ? 'providers.edit_dialog_title' : 'providers.add_dialog_title') | translate }}</h3>
  </div>
  <div class="modal-body">
    <label>
      <span>{{ 'providers.field_provider_type' | translate }}</span>
      <div class="provider-type-selector" [class.disabled]="isDisabled" (click)="$event.stopPropagation()">
        <div class="trigger" [class.disabled]="isDisabled" [attr.aria-disabled]="isDisabled" (click)="toggleOpen()">
          <div class="label">
            <span class="selected" *ngIf="selectedProviderType">{{ selectedProviderType.Name }}</span>
            <span class="placeholder" *ngIf="!selectedProviderType">{{ 'providers.select_provider_type' | translate }}</span>
          </div>
          <span class="chevron" aria-hidden="true"></span>
        </div>

        <div class="panel" *ngIf="open">
          <div class="search">
            <span class="icon" aria-hidden="true"></span>
            <input
              type="text"
              [ngModel]="searchTerm"
              (ngModelChange)="onSearchChange($event)"
              [placeholder]="'provider_selector.search' | translate"
            />
            <button
              class="clear"
              *ngIf="searchTerm"
              (click)="clearSearch()"
              type="button"
              [attr.aria-label]="'provider_selector.clear_search' | translate"
              [attr.title]="'provider_selector.clear_search' | translate"
            >&times;</button>
          </div>

          <ul class="list" *ngIf="!providerTypesLoading">
            <li
              class="item"
              *ngFor="let providerType of filteredProviderTypes"
              [class.active]="providerId === providerType.Id"
              (click)="selectProviderType(providerType)">
              <div class="name">{{ providerType.Name }}</div>
            </li>
            <li class="empty" *ngIf="filteredProviderTypes.length === 0">{{ 'provider_selector.no_results' | translate }}</li>
          </ul>

          <div class="state" *ngIf="providerTypesLoading">{{ 'provider_selector.loading' | translate }}</div>
        </div>
      </div>
    </label>

    <label>
      <span>{{ 'providers.field_url' | translate }}</span>
      <input type="text" [(ngModel)]="url" (ngModelChange)="onCredentialFieldChange()" [disabled]="submitting" />
    </label>

    <label>
      <span>{{ 'providers.field_api_key' | translate }}</span>
      <input type="text" [(ngModel)]="apiKey" [disabled]="submitting" />
    </label>

    <label>
      <span>{{ 'providers.field_username' | translate }}</span>
      <input type="text" [(ngModel)]="username" (ngModelChange)="onCredentialFieldChange()" [disabled]="submitting" />
    </label>

    <label>
      <span>{{ 'providers.field_password' | translate }}</span>
      <input type="password" [(ngModel)]="password" (ngModelChange)="onCredentialFieldChange()" [disabled]="submitting" />
      <small *ngIf="mode === 'edit'">{{ 'providers.password_helper' | translate }}</small>
    </label>

    <div class="error" *ngIf="error">{{ error }}</div>

    <div class="test-status" *ngIf="testResultMessageKey as messageKey"
         [class.success]="testResult?.ok" [class.failure]="!testResult?.ok">
      {{ messageKey | translate }}
    </div>
  </div>
  <div class="modal-footer">
    <button
      *ngIf="isAzugaSelected"
      class="button secondary test-connection"
      type="button"
      (click)="onTestConnection()"
      [disabled]="submitting || testing || providerTypesLoading">
      {{ (testing ? 'providers.testing' : 'providers.test_connection') | translate }}
    </button>
    <button class="button secondary" type="button" (click)="onCancel()" [disabled]="submitting">
      {{ 'providers.cancel' | translate }}
    </button>
    <button class="button" type="button" (click)="onSubmit()" [disabled]="submitting || providerTypesLoading">
      {{ (mode === 'edit' ? 'providers.save' : 'providers.submit') | translate }}
    </button>
  </div>
</div>
